import EventRepository from '../../model/EventRepository'
import AccountConfigRepository from '../../model/AccountConfigRepository'
import EventForm from '../EditEvent/EventForm.vue'
import EventItems from './ViewEventItems.vue'
import uuid from 'uuid'

export default {
  name: 'ViewEventView',

  data () {
    return {
      loading: false,

      regions: [],
      types: [],
      customerGroups: [],

      event: {
        id: null,
        eventCode: '',
        name: '',
        regionId: null,
        startDate: null,
        endDate: null,
        type: null,
        isConfirmed: false,
        isLocked: false,
        notes: null,
        discountedProducts: [],
        specialPromotions: []
      }
    }
  },

  validations: {
    event: {
      name: {},
      eventCode: {},
      startDate: {},
      endDate: {},
      regionId: {},
      type: {}
    }
  },

  components: {
    'event-form': EventForm,
    'event-items': EventItems
  },

  methods: {
    back () {
      this.$router.push('/')
    },

    load () {
      this.loading = true
      let promises = []
      let eventId = this.$route.params.id

      return this.accountConfigRepository.getCustomerGroupIds()
        .then(groupIds => {
          this.customerGroups = this.eventRepository.getCustomerGroups(groupIds)
          this.eventRepository.setMaxCustomerGroupId(groupIds.maxGroupId)
        })
        .then(() => {
          this.types = this.eventRepository.getTypes()
        })
        .then(() => {
          promises.push(
            this.eventRepository.getEvent(eventId)
              .then(event => {
                event.discountedProducts.map(discount => {
                  return Object.assign(discount, {
                    uuid: uuid.v4()
                  })
                })
                event.specialPromotions.map(promotion => {
                  return Object.assign(promotion, {
                    uuid: uuid.v4()
                  })
                })
                this.event = event
              })
          )

          promises.push(
            this.eventRepository.getStoreRegions()
              .then(regions => {
                this.regions = regions
              })
          )

          return Promise.all(promises).then(() => {
            this.loading = false
          })
        })
        .catch(error => {
          this.loading = false
          this.$reportError(error)
        })
    }
  },

  created () {
    this.accountConfigRepository = new AccountConfigRepository(this.$api)
    this.eventRepository = new EventRepository(this.$api)
    this.load()
  }
}



// WEBPACK FOOTER //
// ./src/views/ViewEvent/ViewEvent.js